import { render, staticRenderFns } from "./PayableInstitute.vue?vue&type=template&id=3e887932&scoped=true&"
import script from "./PayableInstitute.vue?vue&type=script&lang=js&"
export * from "./PayableInstitute.vue?vue&type=script&lang=js&"
import style0 from "./PayableInstitute.vue?vue&type=style&index=0&id=3e887932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e887932",
  null
  
)

export default component.exports